import React from 'react';
import ContainerOptions from './ContainerOptions';
import RowOptions from './RowOptions';
import ColumnOptions from './ColumnOptions';
import ElementOptions from './ElementOptions';
import {
  CONTAINER,
  ROW,
  COLUMN,
  ELEMENT
} from '../element-categories';

import styles from '../../../../stylesheet/css/header-builder/options-editor.css';

const renderEditor = (device, props) => {
  const { category, id } = props;

  switch(category) {
    case CONTAINER:
      return <ContainerOptions device={device} {...props} />;
    case ROW:
      return <RowOptions device={device} {...props} />;
    case COLUMN:
      return <ColumnOptions device={device} {...props} />;
    case ELEMENT:
      return <ElementOptions device={device} {...props} />;
    default:
      return 'Unknown';
  }
};

const OptionsEditor = ({ device, highlightedElementModel }) => {
  return (
    <div className={styles.editor}>
      {renderEditor(device, highlightedElementModel)}
    </div>
  );
};

export default OptionsEditor;



// WEBPACK FOOTER //
// ./app/header-builder/components/OptionsEditor.js